import { IonButton, IonCard, IonCardHeader, IonCardTitle, IonCol, IonContent, IonGrid, IonImg, IonPage, IonRow } from "@ionic/react";
import { FC, useEffect, useState } from "react";
import { useParams } from "react-router";
import Footer from "../../components/Footer";
import { translation } from "../../models/translation";
import { fetchNewsByTaxonomy, fetchNewsTaxonomy, fetchSingleNews } from "../../services/new_service";
const News: FC = () => {

    const { id } = useParams<{ id: string; }>();

    const siteText = translation();

    const [lan] = useState(siteText.lan);

    const [news, setNews] = useState<any>(null);
    const [relatedFeeds, setRelatedFeeds] = useState<any>(null);
    const [source, setSource] = useState<any>(null)

    function formatDateToDayMonthYear(dateStr:any) {
        // Convert string to Date object
        let dateObj = new Date(dateStr);
    
        // Get day, month, and year
        let day = dateObj.getDate();
        let month = dateObj.getMonth() + 1; // Adding 1 since getMonth() returns zero-based month index
        let year = dateObj.getFullYear();
    
        // Format the date
        let formattedDate = day + "-" + month + "-" + year;
    
        return formattedDate;
    }

    useEffect(() => {
        fetchSingleNews(id).then(
            m => {

                fetchNewsByTaxonomy(m.message.categories.join()).then(
                    n => {
                        setRelatedFeeds(n.message.filter((el: any) => el.id !== m.message.id).slice(0, 4))
                    }
                )
                fetchNewsTaxonomy(m.message.categories[0]).then(
                    l => {
                        setSource(l.message)
                    }
                )
                setRelatedFeeds(relatedFeeds)
                setNews(m.message);
            }
        )
    }, [id])

    const HeaderImage = () => {
        if (!news._embedded) return (<></>);
        if (news._embedded['wp:featuredmedia']) {
            return (
                <div className="header_273 ">
                    <img alt="" style={{ width: '100%', borderRadius: '15px 15px 0 0' }} src={news._embedded['wp:featuredmedia'][0].source_url}></img>
                </div>
            )
        } else { return <></> }
    }


    return (
        <IonPage >
            <IonContent  >
                <div className="mainContent">
                    {
                        news &&
                        <>
                            <IonGrid className="article-body">
                                <IonRow >
                                    <IonCol className="article-header" sizeXl="10" offsetXl="1" style={{ display: "block", padding: '0' }}>
                                        <HeaderImage></HeaderImage>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol className="ion-padding" style={{ backgroundColor: 'white' }} offsetXl="1" sizeXl="10">
                                        <IonRow>
                                            <IonCol sizeSm="8" sizeMd="9">
                                                <p>{siteText.newsPublishDateTitle}: {formatDateToDayMonthYear(news.date)}</p>
                                                <h1 dangerouslySetInnerHTML={{__html:news.title.rendered}}></h1>
                                                <p>{source ? `${siteText.feedsArticleSourceKey}:${source.name}` : ""}</p>


                                                <div dangerouslySetInnerHTML={{ __html: news.content.rendered }}>
                                                </div>
                                            </IonCol>
                                            <IonCol>
                                                <h4 className="ion-margin-start">{siteText.feedsRelatedArticles}</h4>
                                                {
                                                    !relatedFeeds ? <></> :
                                                        relatedFeeds.map((relFeed: any) => {
                                                            return (
                                                                <IonCard routerLink={`${lan}/articles/${relFeed.id}`} className="ion-margin-bottom" key={relFeed.id} >
                                                                    <IonCardHeader>
                                                                        {!relFeed._embedded['wp:featuredmedia'] ? <></> :
                                                                            <IonImg src={relFeed._embedded['wp:featuredmedia'][0].source_url}></IonImg>
                                                                        }
                                                                        <IonCardTitle dangerouslySetInnerHTML={{__html:relFeed.title.rendered}}></IonCardTitle>
                                                                    </IonCardHeader>
                                                                </IonCard>
                                                            )
                                                        })
                                                }
                                                <IonButton className="ion-margin-start" fill="outline" routerLink={`${lan}/articles`} >{siteText.feedsViewMore}</IonButton>
                                            </IonCol>
                                        </IonRow>
                                    </IonCol>
                                </IonRow>

                            </IonGrid>
                        </>

                    }
                    <Footer></Footer>
                </div>
            </IonContent>
        </IonPage >
    )

}

export default News;